var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="nfd-loader nfd-loader-inactive nfd-loader-full nfd-anim-fast fadeIn"> <div class="nfd-loader-item-centered"> <!-- ko template: { name: \'loader-template\'} --><!-- /ko --> </div> </div> <script type="text/html"id="loader-template"><i class="fa fa-spinner fa-pulse"></i></script>';
}
return __p;
};
